import type { ReactNode } from 'react';
import { Container, FullPage } from '@backstage/ui';
import {
  PluginPageHeader,
  type PluginPageHeaderProps,
} from '../PluginPageHeader';
import classes from './PluginPage.module.css';

/**
 * Content width.
 *
 * - `full`: the content lines up with the header title.
 * - `default`: a centred 1200px column.
 * - `form`: a centred 720px column.
 */
export type PluginPageWidth = 'default' | 'form' | 'full';

export type PluginPageProps = PluginPageHeaderProps & {
  width?: PluginPageWidth;
  children?: ReactNode;
};

/**
 * Page layout for every portal plugin page: the BUI header, then the page
 * content, both inside the BUI scroll region. The header scrolls away with
 * the content, and the page has one scroll bar.
 *
 * The header keeps the full page width. Only the content column narrows.
 */
export const PluginPage = ({
  width = 'default',
  children,
  ...headerProps
}: PluginPageProps) => {
  return (
    <FullPage className={classes.page} data-plugin-page-width={width}>
      <PluginPageHeader {...headerProps} />
      <Container className={classes.content}>{children}</Container>
    </FullPage>
  );
};
